import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';
import { locationStore, languageStore, LocationInterface, educationStore, EducationInterface, userStore } from 'stores';
import TableHeader from 'components/Table/TableHeader';
import { required } from 'helpers/FormValidation';
import DetailsPage from '../DetailsPage';
import * as _ from 'lodash';
import { ModalColumn } from 'components/Modal';
import ContractDetailsItem from 'components/ContractDetailsItem';
import Location from 'components/Forms/Location';

@observer class EducationPage extends React.Component {

    form = new FormState({
        id: new FieldState<null | string>(null),
        name: new FieldState(null).validators(required),
        locationId: new FieldState(null).validators(required)
    })

    componentDidMount() {
        const companyId = userStore.signedInUser.company.id;
        locationStore.getLocationsByCompany(companyId);

        educationStore.getAllEducations();
    }

    onDelete = async (id: string) => {
        const eq = _.find(educationStore.allEducations, { id: id }) as EducationInterface;
        const locationId = eq.locationId;

        await educationStore.deleteEducation(locationId, id);
    }

    render() {
        const data = educationStore.allEducations || [];
        const locations = locationStore.locations || [];
        const form = this.form.$;
        const isNewEntity = !!!form.id.$;

        const columns = [
            {
                Header: <TableHeader value={languageStore.get('name')} />,
                accessor: 'name'
            },
            {
                Header: <TableHeader value={languageStore.get('location')} />,
                id: 'locationId',
                accessor: (d: any) => {
                    const loc = _.find(locations, { id: d.locationId }) as LocationInterface;
                    return loc ? loc.name : '-';
                }
            },
        ]

        return (
            <DetailsPage
                fullWidth={true}
                generalTitle={languageStore.get('educations')}
                modalTitle={languageStore.get('educations')}
                form={this.form}
                onUpdate={(edu: EducationInterface) => educationStore.updateEducation(edu)}
                onSubmit={(edu: EducationInterface) => educationStore.createEducation(edu)}
                onDelete={(id: string) => this.onDelete(id)}
                collection={data}
                columns={columns}>

                <ModalColumn>

                    <ContractDetailsItem
                        fieldState={form.name}
                        label={languageStore.get('name')}
                        id='name'
                        editMode={true} />

                    {
                        isNewEntity &&
                        <Location fieldState={form.locationId} editMode={true} />
                    }

                </ModalColumn>

            </DetailsPage>
        )
    }

}

export default EducationPage;